import React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Dispatch, bindActionCreators } from 'redux';
import { Icon } from 'antd';
import { DeliveryCode } from 'Store/Order/enums';
import { fetchTicketPDF } from 'Store/Order/thunks';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import Button from 'Components/Shared/Button/Button';

interface IProps {
  orderID: number;
  orderBarcode: string;
  deliveryCode: string;
}

interface IPropsInternal {
  fetchTicketPDF: (orderID: number) => void;
}

type Props = IProps & IPropsInternal;

class DownloadTicketsButton extends React.PureComponent<Props> {

  onClick = () => {
    this.props.fetchTicketPDF(this.props.orderID);
  }

  render() {

    const { orderID, orderBarcode, deliveryCode } = this.props;

    const isSMS = deliveryCode === DeliveryCode.TEXT_MESSAGE;
    const isPDF = deliveryCode=== DeliveryCode.E_TICKET;

    if (!isSMS && !isPDF) {
      return null;
    }
  
    return (
      <Button 
        style='download-tickets-button'
        color='purple' 
        boxShadow={ true }
        onClick={ isPDF ? this.onClick : undefined }
        redirectUrl={ isSMS ? `${ process.env.REACT_APP_API_URL }/MT/${ orderID }/${ orderBarcode }` : undefined }
      >
        <Icon 
          type='download' 
          style={ { marginRight: '8px' } } 
        />
        <FormattedText
          displayName='Biljetter'
          formattedName='order.download.tickets'
        />
      </Button>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchTicketPDF,
  }, dispatch);
};

export default compose<{}, {}>(
  injectIntl,
  connect(null, mapDispatchToProps),
)(DownloadTicketsButton);


// WEBPACK FOOTER //
// ./src/components/DownloadTicketsButton/DownloadTicketsButton.tsx